export default {
    publicAccess: ['login', 'account-reset-password', 'account-update-email-confirm'],
    usertypes: {
        'admin': 1,
        'clientadmin': 2,
        'pm': 3,
        'client': 4
    },
    layertypes: {
        layer: [
            {
                id: "AC 5 DL / 70/100",
                title: "AC 5 DL / 70/100"
            },
            {
                id: "AC 8 DN / 50/70",
                title: "AC 8 DN / 50/70"
            },
            {
                id: "AC 8 DN / 70/100",
                title: "AC 8 DN / 70/100"
            },
            {
                id: "AC 8 DS / 25/55-55",
                title: "AC 8 DS / 25/55-55"
            },
            {
                id: "AC 8 DS / 50/70",
                title: "AC 8 DS / 50/70"
            },
            {
                id: "AC 11 DN / 70/100",
                title: "AC 11 DN / 70/100"
            },
            {
                id: "AC 11 DS / 25/55-55",
                title: "AC 11 DS / 25/55-55"
            },
            {
                id: "AC 11 DS / 50/70",
                title: "AC 11 DS / 50/70"
            }
        ],
        base: [
            {
                id: "AC 16 TN / 50/70",
                title: "AC 16 TN / 50/70"
            },
            {
                id: "AC 16 TN / 70/100",
                title: "AC 16 TN / 70/100"
            },
            {
                id: "AC 22 TN / 50/70",
                title: "AC 22 TN / 50/70"
            },
            {
                id: "AC 22 TN / 70/100",
                title: "AC 22 TN / 70/100"
            },
            {
                id: "AC 22 TS / 50/70",
                title: "AC 22 TS / 50/70"
            },
            {
                id: "AC 22 TS / 30/45",
                title: "AC 22 TS / 30/45"
            },
            {
                id: "AC 32 TN / 50/70",
                title: "AC 32 TN / 50/70"
            },
            {
                id: "AC 32 TN / 70/100",
                title: "AC 32 TN / 70/100"
            },
            {
                id: "AC 32 TS / 50/70",
                title: "AC 32 TS / 50/70"
            },
            {
                id: "AC 32 TS / 30/45",
                title: "AC 32 TS / 30/45"
            }
        ],
        wear: [
            {
                id: "AC 16 TD / 50/70",
                title: "AC 16 TD / 50/70"
            },
            {
                id: "AC 16 TD / 70/100",
                title: "AC 16 TD / 70/100"
            }
        ],
        binder: [
            {
                id: "AC 16 BN / 50/70",
                title: "AC 16 BN / 50/70"
            },
            {
                id: "AC 16 BS / 25/55-55",
                title: "AC 16 BS / 25/55-55"
            },
            {
                id: "AC 16 BS / 30/45",
                title: "AC 16 BS / 30/45"
            },
            {
                id: "AC 22 BS / 25/55-55",
                title: "AC 22 BS / 25/55-55"
            },
            {
                id: "AC 22 BS / 30/45",
                title: "AC 22 BS / 30/45"
            }
        ],
        mastic: [
            {
                id: "SMA 5 N / 70/100",
                title: "SMA 5 N / 70/100"
            },
            {
                id: "SMA 8 N / 50/70",
                title: "SMA 8 N / 50/70"
            },
            {
                id: "SMA 8 S / 25/55-55",
                title: "SMA 8 S / 25/55-55"
            },
            {
                id: "SMA 11 S / 25/55-55",
                title: "SMA 11 S / 25/55-55"
            }
        ]
    },
    countries: require('./data/countries_de.json'),

    /**
     * Returns the country name for the given `countryCode`. Returns `undefined`
     * if the given country code doesn’t point to a country in our list.
     *
     * @param {String} countryCode
     *
     * @returns {String | undefined}
     */
    getCountryNameByCountryCode(countryCode) {
        return this.countries[countryCode]
    },

    titles: ['Dr.', 'Prof.', 'Prof. Dr.', 'Dipl.-Inf.', 'Dipl.-Ing.'],
    active: [1, 0],
    statuses: ['open', 'busy', 'finished', 'cancelled', 'notcancelled'],
    placementTypes: ['street', 'sidewalk'],
    dateFormat: 'dd.MM.yyyy',
    disabledDates: {
        days: [6, 0],
    },
    uploads: ['jpg', 'jpeg', 'png', 'pdf'],
    formatNumber: function (value) {
        // help from https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formateCurrency: function (value) {
        return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(value);
    },
    limitString: function (value, length, suffix) {
        if (value.length > length) {
            return value.substring(0, length) + suffix;
        }
        return value;
    },
    /**
     * Push a query only when it differs from the current one.
     * Vue Router rejects a push to the current location with NavigationDuplicated.
     */
    pushQuery: function (router, currentQuery, nextQuery) {
        let nextKeys = Object.keys(nextQuery);
        let currentKeys = Object.keys(currentQuery);
        let sameLocation = nextKeys.length === currentKeys.length && nextKeys.every(function (key) {
            return String(nextQuery[key]) === String(currentQuery[key]);
        });

        if (sameLocation) {
            return Promise.resolve();
        }

        return router.push({ query: nextQuery }).catch(function (error) {
            if (error.name !== "NavigationDuplicated") {
                throw error;
            }
        });
    },
    /**
     * First day that may be chosen as an earliest start.
     * Today is not counted. Saturday and Sunday are skipped.
     */
    firstSelectableEarliestStart: function (fromDate) {
        let cursor = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
        let remaining = 5;
        while (remaining > 0) {
            cursor.setDate(cursor.getDate() + 1);
            let day = cursor.getDay();
            if (day !== 0 && day !== 6) {
                remaining--;
            }
        }
        return cursor;
    },
    dateFromIso: function (value) {
        if (value instanceof Date) {
            return value;
        }
        if (typeof value !== "string" || value === "") {
            return null;
        }
        let match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (!match) {
            return null;
        }
        return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    },
    formatEarliestStart: function (value) {
        let date = this.dateFromIso(value);
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
            return "";
        }
        let month = String(date.getMonth() + 1).padStart(2, "0");
        let day = String(date.getDate()).padStart(2, "0");
        return date.getFullYear() + "-" + month + "-" + day;
    },
    formatEarliestStartLabel: function (value) {
        let formatted = this.formatEarliestStart(value);
        if (formatted === "") {
            return "";
        }
        let parts = formatted.split("-");
        return parts[2] + "." + parts[1] + "." + parts[0];
    },
    isEarliestStartAllowed: function (value) {
        if (value === null || value === "" || typeof value === "undefined") {
            return true;
        }
        let date = this.dateFromIso(value);
        if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
            return false;
        }
        let day = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        let weekday = day.getDay();
        if (weekday === 0 || weekday === 6) {
            return false;
        }
        return day.getTime() >= this.firstSelectableEarliestStart(new Date()).getTime();
    },
    projectPayload: function (object) {
        let payload = Object.assign({}, object);
        payload.earliest_start = this.formatEarliestStart(object.earliest_start);
        delete payload.requested_deadline;
        return payload;
    },
    logger: function () {
        try {
            console.log.apply(console, arguments);
        } catch (e) {
            try {
                opera.postError.apply(opera, arguments);
            }
            catch (e) {
                alert(Array.prototype.join.call(arguments, " "));
            }
        }
    },
    history: null
};
